// extracted by mini-css-extract-plugin
var _1 = "PostDetailPreviewStateBar-module__animateUploadProgressBarWidth--HHmV_";
var _2 = "PostDetailPreviewStateBar-module__animatedBackground--n58er";
var _3 = "PostDetailPreviewStateBar-module__archived--QmefZ";
var _4 = "PostDetailPreviewStateBar-module__container--JXvR2";
var _5 = "PostDetailPreviewStateBar-module__content--Gx_Nh";
var _6 = "PostDetailPreviewStateBar-module__draft--dZdJK";
var _7 = "PostDetailPreviewStateBar-module__template--j9E05";
var _8 = "PostDetailPreviewStateBar-module__verified--CHSVH";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "archived", _4 as "container", _5 as "content", _6 as "draft", _7 as "template", _8 as "verified" }
